export default function CTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div 
          className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-purple-600 to-blue-600"
        >
          <div className="relative z-10 py-20 px-8 lg:px-16 text-center">
            <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6">
              Ready to Start Your Project?
            </h2>
            
            <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
              Let's bring your vision to life. Get in touch with our team today and discover how DynastyForge can transform your digital presence.
            </p>
            
            <div className="flex flex-wrap justify-center gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap group"
              >
                Get Started Now
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
              </button>
              <button className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold border-2 border-white/30 hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap">
                Schedule a Call
              </button>
            </div>

            <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-white/80">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-2xl"></i>
                <span>Free Consultation</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-2xl"></i>
                <span>No Obligation Quote</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-2xl"></i>
                <span>24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
